import { PaletteColor, Theme } from '@mui/material';

export enum ReportStatus {
  Queued = 0,
  Processing = 1,
  Completed = 2,
  Failed = 3,
}

export const ReportStatusTranslationMap = {
  [ReportStatus.Queued]: 'reporting.status.queued',
  [ReportStatus.Processing]: 'reporting.status.processing',
  [ReportStatus.Completed]: 'reporting.status.completed',
  [ReportStatus.Failed]: 'reporting.status.failed',
} as const;

export function getReportStatusPalette(status: ReportStatus, theme: Theme): PaletteColor {
  switch (status) {
    case ReportStatus.Processing:
      return theme.palette.custom.blue;
    case ReportStatus.Completed:
      return theme.palette.success;
    case ReportStatus.Failed:
      return theme.palette.error;
    case ReportStatus.Queued:
    default:
      return theme.palette.custom.gray;
  }
}
